import React, { useEffect, useMemo } from 'react';
import { EduCourseForm } from './EduCourseForm.jsx';
import { AppBarCMS } from '../../../../../basic';
import { useTranslation } from 'react-i18next';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import {
  useGetEduCourseQuery,
  useGetEduLecturersQuery,
  useSaveEduCourseMutation,
} from '../../../../../../redux/services/eduCourses';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner } from '../../../../../common';
import { makeLecturerableOption } from '../../../../../../utils/helpers/CommonHelper';
import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';

export const EduCourseEdit = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const isEdit = !isUndefined(id);

  useEffect(() => {
    const title = !isEdit ? t('Pridanie kurzu') : t('Editácia kurzu');
    document.title = 'FRI.edu - ' + title;
  }, [isEdit, t]);

  const { data: eduCourseDetail, isLoading } = useGetEduCourseQuery(id, {
    skip: !isEdit,
  });

  const { saveSuccess, saveFailed } = useToastMessages();

  const [
    saveEduCourse,
    { isSuccess: isSaveSuccess, isError: isSaveError, error: saveError },
  ] = useSaveEduCourseMutation();

  const { data: eduLecturers } = useGetEduLecturersQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsCoursesList);
      // List will auto-refresh via RTK Query invalidation
    }
  }, [isSaveSuccess, navigate, saveSuccess]);

  useEffect(() => {
    if (isSaveError && saveError) {
      // Show validation or server error message
      saveFailed(saveError);
    }
  }, [isSaveError, saveError, saveFailed]);

  // In create mode, wait for user to be loaded to prefill lecturerable
  const isCreateWaitingForUser = !isEdit && !user;

  const initials = useMemo(() => {
    // Create mode: if user not ready yet, avoid building initials
    if (!eduCourseDetail) {
      if (!user) return {};
      return {
        lecturerable: makeLecturerableOption(user).value,
      };
    }

    return {
      ...eduCourseDetail,
      lecturerable: eduCourseDetail?.lecturerable
        ? makeLecturerableOption(eduCourseDetail.lecturerable).value
        : undefined,
      other_lecturers: (eduCourseDetail?.lecturers || []).map(
        (lecturer) => makeLecturerableOption(lecturer.lecturerable).value,
      ),
    };
  }, [eduCourseDetail, user]);

  return (isEdit && isLoading) || isCreateWaitingForUser ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={!isEdit ? t('Pridanie kurzu') : t('Editácia kurzu')}
        backUrl={routes.cmsCoursesList}
        backUrlTooltip={t('Zoznam kurzov')}
      />
      <div style={{ margin: '10px' }}>
        <EduCourseForm
          initials={initials}
          eduLecturers={eduLecturers || []}
          onSubmit={(values) => {
            saveEduCourse({ body: values, id });
          }}
        />
      </div>
    </>
  );
};

export default EduCourseEdit;
